import classNames from 'classnames'
import React, { useCallback } from 'react'
import { Column } from 'react-table'
import { Table, TableProps } from 'scenes/Dashboard/components-next/Table'
import { makeStyles } from 'tss-react/mui'

import { Paper, TablePagination, Theme } from '@mui/material'

import { useSubspaceDataRows } from './SubspaceRow.data'
import { Subspace } from '../../../../../../entities-next/subspace'

export const SubspaceTable = React.memo(
  ({ className, data, currentPage, limit, onChangePage, onRowSelect, extraColumns = [] }: SubspaceTableTableProps) => {
    const { classes } = useStyles()
    const columns = useSubspaceDataRows(extraColumns)

    // TODO: Wait for the real count from back
    const hardcodedCount = getHardcodedCount(data, currentPage, limit)
    const handlePageChange = useCallback(
      (event: any, page: number) => {
        // Due to a bug of material UI, tables fire this callback on re-renders
        if (Boolean(event)) {
          onChangePage(page)
        }
      },
      [onChangePage]
    )
    const tablePagination = (keyPrefix: string, borderBottom: boolean = true) => (
      <table className={classNames(className, classes.paginationTable)}>
        <tbody>
          <tr>
            <TablePagination
              className={classNames(className, classes.pagination, !borderBottom ? classes.removeBorderBottom : '')}
              key={keyPrefix + currentPage}
              count={hardcodedCount}
              rowsPerPage={limit}
              page={currentPage}
              rowsPerPageOptions={[]}
              backIconButtonProps={{ 'aria-label': 'Previous Page' }}
              nextIconButtonProps={{ 'aria-label': 'Next Page' }}
              onPageChange={handlePageChange}
            />
          </tr>
        </tbody>
      </table>
    )

    return (
      <Paper elevation={2} className={classNames(className, classes.root)}>
        {tablePagination('top-pagination-')}
        <Table<Subspace> className={classes.table} columns={columns} data={data} onRowSelect={onRowSelect} />
        {tablePagination('bottom-pagination-', false)}
      </Paper>
    )
  }
)

export type SubspaceTableTableProps = Omit<TableProps<Subspace>, 'columns' | 'shouldHighlight'> & {
  currentPage: number
  limit: number
  onChangePage: (page: number) => void
  extraColumns?: Column<Subspace>[]
}

SubspaceTable.displayName = 'SubspaceTable'

function getHardcodedCount(data: Subspace[], currentPage: number, limit: number) {
  return limit > data.length ? data.length : limit * (currentPage + 1) + 1
}

const useStyles = makeStyles()(({ palette }: Theme) => ({
  root: {
    width: '100%',
    overflowX: 'auto',
  },
  table: {
    tableLayout: 'fixed',
  },
  paginationTable: {
    width: '100%',
  },
  pagination: {
    width: '100%',
    display: 'flex',
  },
  removeBorderBottom: {
    borderBottom: `0px solid ${palette.grey[400]}`,
  },
}))
